import React, {useContext, useEffect} from 'react';
import {currencyFormat} from "../../Utils/currencyFormat";
import {Divider} from "@mantine/core";
import {useParams} from "react-router-dom";
import CotizarContext from "../../../context/CotizarContext";
import { trackPageView, trackCustomEvent } from "../../../utils/analytics/analytics";
import { ANALYTICS_SECTIONS } from "../../../constants/analyticsConstants";
import { getQuotationModule } from "../../../utils/analytics/analyticsHelpers";

function CotizacionSuccess(props) {
    const {cotizacionResponse, BottomInfo} = props;
    const {coberturasInfo} = useContext(CotizarContext);
    const params = useParams();

    useEffect(() => {
        if (cotizacionResponse !== "Error") {
            cotizacionResponse['detalleCoberturas']["obligatorias"].sort((a, b) => parseInt(a.numeroCobertura) - parseInt(b.numeroCobertura));
            cotizacionResponse['detalleCoberturas']["adicionales"].sort((a, b) => parseInt(a.numeroCobertura) - parseInt(b.numeroCobertura));
            
            // Trackear page view cuando la cotización es exitosa
            trackPageView({
                module: getQuotationModule(params['producto']),
                section: ANALYTICS_SECTIONS.QUOTATION_RESPONSE_SUCCESS,
                pageTitle: 'Cotización exitosa'
            });
        } else {
            // Trackear page view cuando hay error general
            trackPageView({
                module: getQuotationModule(params['producto']),
                section: ANALYTICS_SECTIONS.QUOTATION_RESPONSE_ERROR,
                pageTitle: 'Error en cotización'
            });
        }
        
        // Trackear evento personalizado quote_response siempre que se renderice la respuesta
        trackCustomEvent({
            eventName: 'quote_response'
        });
    }, [cotizacionResponse, params]);

    return (
        <React.Fragment>
                {cotizacionResponse === "Error"
                    ?
                        <div className="structure__margin--topLG">
                            <p className="form__subtitle structure__center">
                                Hubo un problema al cotizar. Por favor, vuelva a intentarlo más tarde.
                            </p>
                        </div>
                    :
                    <>
                        <p className="form__text--primary structure__start">
                            Resumen de cotización:
                        </p>

                        <p className="form__subtitle" style={{fontWeight: "600"}}>
                            Cuota Mensual: ${cotizacionResponse['premioMensual'].toFixed(0)}
                        </p>

                        <Divider my="sm" size="xs"/>

                        <p className="form__text--primary structure__start structure__margin--topOnly">
                            Detalle Coberturas:
                        </p>

                        {cotizacionResponse['detalleCoberturas']["adicionales"].map((item) => (
                            <div className="form__body">
                                <p className="form__text--dark">{coberturasInfo[item.numeroCobertura].descripcion}</p>
                                <p className="form__text--light">{`Suma Asegurada: $ ${currencyFormat(item.sumaAsegurada)}`}</p>
                            </div>
                        ))}
                        <p className="form__note">* La aseguradora indemnizará los daños hasta las sumas aseguradas
                            contratadas.</p>
                        {BottomInfo && <p className="form__bottomInfo"><BottomInfo /></p>}
                    </>
                }
        </React.Fragment>
    );
}

export default CotizacionSuccess;
